import type { Session } from '#src/shared/session';

export function isGuest(session: Session) {
	return session.loginState === 'GUEST';
}
